import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet } from 'react-native';

import ChevronRight from '@/assets/icons/chevronRight';
import { Text } from '@/components/TextComponent';
import { Box, Image, Row, TouchableBox } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';

import { AllLeaguesItem } from '../utils/all-leagues-utils';

type AllLeaguesRowProps = {
    league: AllLeaguesItem;
    onPress: (league: AllLeaguesItem) => void;
};

export const AllLeaguesRow = memo(({ league, onPress }: AllLeaguesRowProps) => {
    const { t } = useTranslation('common');

    return (
        <TouchableBox
            accessibilityRole={'button'}
            py={'s16'}
            disabled={league.isOffseason || league.disabled}
            opacity={league.disabled ? 0.3 : 1}
            onPress={() => onPress(league)}
        >
            <Row flex={1} alignItems={'center'} gap={'s16'}>
                {league.image ? (
                    <Image source={league.image} resizeMode={'contain'} style={styles.image} />
                ) : (
                    <Box style={styles.image} />
                )}
                <Text variant={'bodyMedium'} color={ds.colorToken.text.primary} numberOfLines={1} style={styles.label}>
                    {league.label}
                </Text>
                {league.isOffseason ? (
                    <Box
                        paddingHorizontal={'s6'}
                        paddingVertical={'s4'}
                        borderRadius={'r7'}
                        backgroundColor={ds.colorToken.background.neutral.subtle}
                    >
                        <Text variant={'labelMedium'} color={'neutral300'}>
                            {t('offseason')}
                        </Text>
                    </Box>
                ) : (
                    <ChevronRight />
                )}
            </Row>
        </TouchableBox>
    );
});

const styles = StyleSheet.create({
    image: {
        width: 24,
        height: 24,
    },
    label: {
        flex: 1,
    },
});
